<div class="card fin-seguimiento-modal">
  <header class="card-header card-header-primary fin-seguimiento-modal__header">
    <div class="fin-seguimiento-modal__header-copy">
      <h4 class="card-title"><b>Finalizar seguimiento</b></h4>
      <p class="card-category">Registra la causa y actualiza el estatus del prospecto.</p>
    </div>
    <button mat-icon-button type="button" class="fin-seguimiento-modal__close" aria-label="Cerrar" (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </header>

  <div class="card-body fin-seguimiento-modal__body">
    <form [formGroup]="datosform" class="fin-seguimiento-modal__form">
      <mat-form-field class="fin-seguimiento-modal__field--full">
        <mat-label>Causa</mat-label>
        <textarea matInput aria-label="Causa" rows="4" maxlength="500" formControlName="causa" [(ngModel)]="objetoProspecto.causa"></textarea>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Estatus</mat-label>
        <mat-select formControlName="estatus" [(ngModel)]="objetoProspecto.estatus">
          <mat-option *ngFor="let option of estatusOptions" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>

      <footer class="fin-seguimiento-modal__actions">
        <button mat-button type="button" class="btn btn-danger" (click)="onNoClick()">
          <i class="fa fa-times-circle-o"></i> Cancelar
        </button>
        <button mat-button type="button" class="btn btn-success" [disabled]="datosform.invalid" (click)="guardaProspecto()">
          Guardar <i class="material-icons">save</i>
        </button>
      </footer>
    </form>
  </div>
</div>
